import React from "react";
import ReactDOM from "react-dom";
import { Router, Redirect } from "@reach/router";
import { addLocaleData } from "react-intl";
import fi from "react-intl/locale-data/fi";
import sv from "react-intl/locale-data/sv";

import { App } from "./App";
import { Frontpage } from "./Frontpage/Frontpage";
import { OperatorSearch } from "./OperatorSearch/OperatorSearch";
import { RefrigerationSearch } from "./RefrigerationSearch/RefrigerationSearch";
import { NameStampSearch } from "./NameStampSearch/NameStampSearch";
import { SprayTesterSearch } from "./SprayTesterSearch/SprayTesterSearch";
import { PesticideInstructorSearch } from "./PesticideInstructorSearch/PesticideInstructorSearch";
import { PestControlOperatorSearch }from "./PestControlOperatorSearch/PestControlOperatorSearch";
import { PestControlCompetencySearch } from "./PestControlCompetencySearch/PestControlCompetencySearch";

// window.fetch polyfill
import "whatwg-fetch";

// polyfill ES6 Array.find & Number.isInteger for IE 11
import "core-js/fn/array/find";
import "core-js/fn/number/is-integer";

// global styles
import "./index.css";

// add react-intl locales for finnish and swedish
addLocaleData([...fi, ...sv]);

ReactDOM.render(
  <Router>
    <App path='/'>
      <Frontpage path='/' />
      <OperatorSearch path='toiminnanharjoittajat' />
      <RefrigerationSearch path='kylma-alan-patevyys' />
      <SprayTesterSearch path='ruiskuntestaajan-patevyys' />
      <PesticideInstructorSearch path='kasvinsuojelukoulutuksen-ja-tutkinnonjarjestajan-patevyys' />
      <PestControlOperatorSearch path='tuholaistorjunnan-toiminnanharjoittajat' />
      <PestControlCompetencySearch path='tuholaistorjunnan-patevyys' />
      <NameStampSearch path='nimileimat' />
      <Redirect from='/' to='/' default noThrow />
    </App>
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js